export default {
  en: {
    placeholder: 'Enter a number',
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    orLess: '{0} or less',
    require: 'Require at most',
    requireCol: 'At most {n}',
    requireHeading: 'At most',
    notRequired: 'Not required',
    outOfScope: 'Out of scope',
    answer: 'Answer',
    answered: 'Answered',
    youAnswered: 'You answered',
    editAnswer: 'Edit answer',
    lastModified: 'Last modified {0}',
    dateFormat: 'YYYY/MM/DD',
  },
};
